class CollapsibleTab extends HTMLElement {
  constructor() {
    super();
    this.contentHeight = 0;
    this.content = this.querySelector('.collapsible-content');
    this.trigger = this.querySelector('.collapsible-trigger');
    this.icon = this.querySelector('.collapsible-icon');
    this.trigger.addEventListener('click', this.toggle.bind(this));
    window.addEventListener('resize', () => {
      if(this.contentHeight > 0) {
        this.calcHeight();
        this.content.style.height = `${this.contentHeight}px`;
      }
    });
  }

  connectedCallback() {
    if(this.hasAttribute('data-open')) {
      this.open();
    }
  }

  calcHeight() {
    const clone = this.content.cloneNode(true);
    Object.assign(clone.style, {
      overflow: 'visible',
      height: 'auto',
      maxHeight: 'none',
      opacity: '0',
      visibility: 'hidden',
      display: 'block'
    });
    this.content.after(clone);
    this.contentHeight = clone.offsetHeight + 10;
    clone.remove();
  }

  toggle() {
    this.contentHeight === 0 ? this.open() : this.close();
  }

  open() {
    this.calcHeight();
    this.content.style.height = `${this.contentHeight}px`;
    this.icon.innerHTML = "<svg xmlns='http://www.w3.org/2000/svg' height='1em' viewBox='0 0 56.05 56.05' aria-hidden='true' fill='inherit' class='w-4 h-4 stroke-inherit rotate-45'> <defs> <style> .cls-1 { fill: none; stroke-miterlimit: 10; stroke-width: 2.74px; } </style> </defs><g id='Layer_1-2' data-name='Layer 1'><g  class='transition-colors'><circle class='cls-1' cx='28.02' cy='28.02' r='15.92' /><line class='cls-1' x1='28.02' y1='0' x2='28.02' y2='56.05' /> <line class='cls-1' x1='56.05' y1='28.02' x2='0' y2='28.02' /></g></g></svg>";
  }

  close() {
    this.content.style.height = '0px';
    this.contentHeight = 0;
    this.icon.innerHTML = "<svg xmlns='http://www.w3.org/2000/svg' height='1em' viewBox='0 0 56.05 56.05' aria-hidden='true' fill='inherit' class='w-4 h-4 stroke-inherit'> <defs> <style> .cls-1 { fill: none; stroke-miterlimit: 10; stroke-width: 2.74px; } </style> </defs><g id='Layer_1-2' data-name='Layer 1'><g  class='transition-colors'><circle class='cls-1' cx='28.02' cy='28.02' r='15.92' /><line class='cls-1' x1='28.02' y1='0' x2='28.02' y2='56.05' /> <line class='cls-1' x1='56.05' y1='28.02' x2='0' y2='28.02' /></g></g></svg>";
  }
}

if (!customElements.get('collapsible-tab')) {
  customElements.define('collapsible-tab', CollapsibleTab);
}